import { apiRequest } from './client'
import type { Paginated, TimeTrackingEntry, TimeTrackingSummary } from './types'

export interface TimeTrackingFilterParams {
  projectId?: string
  userId?: string
  dateFrom?: string
  dateTo?: string
}

export const timeTrackingApi = {
  list: (params: TimeTrackingFilterParams & { page?: number; pageSize?: number } = {}) =>
    apiRequest<Paginated<TimeTrackingEntry>>('/time-tracking', { query: params as Record<string, string | number | boolean | undefined> }),
  summary: (params: TimeTrackingFilterParams = {}) =>
    apiRequest<{ data: TimeTrackingSummary }>('/time-tracking/summary', { query: params as Record<string, string | number | boolean | undefined> }),
}
